const $ = document.querySelector.bind(document);

const CLASS_OPEN = 'is-open';
const NAV_TOGGLE = '.js-nav-toggle';
const NAV_SUB_TOGGLE = '.js-nav__sub-toggle';

const $header = $('.header__nav');
const $nav = $('#nav');

$header.addEventListener('click', function (e) {
    if (e.target.closest(NAV_TOGGLE)) {
        e.preventDefault();

        $nav.classList.toggle(CLASS_OPEN);
    }

    if (e.target.closest(NAV_SUB_TOGGLE)) {
        e.preventDefault();

        const subNavId = e.target.hash;

        $(subNavId).classList.toggle(CLASS_OPEN);
    }
});
